import * as React from 'react';
import { Button, Typography } from 'onboarding-components';
import { apiClient } from 'common/util/api-client';
import { objToFormData } from 'common/util';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { reporter } from 'common/report/error-reporting';
import { ModalReact } from 'common/components/modal';
import { IMMERSIVE_ASSETS } from 'common/onboarding/immersive-onboarding/assets';
import { useTranslation } from 'common/i18n/hooks';
import { useLocalStorageManager } from 'common/contexts/react/storage-manager-context';
import { useMountEffect } from '../utils';
import { track, TrackingEvent } from './tracking';
import styles from './index.module.styl';
import { SetupGuideContext } from './types';
export const ImmersiveOnboardingMobile = () => {
  const {
    t
  } = useTranslation();
  const localStorageManager = useLocalStorageManager();
  const [openMobileModal, setOpenModalModal] = React.useState(true);
  const [sentCounter, setSentCounter] = React.useState(0);
  const MOBILE_MODAL_SHOWN_STORAGE_KEY = "mobile-immersive-modal-has-shown";
  const EMAIL_SENT_LIMIT = 3;
  const [isMobileDevice, setIsMobileDevice] = React.useState(false);
  useMountEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(window.outerWidth < 1200);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  const {
    setupGuideInfo
  } = React.useContext(SetupGuideContext);
  const handleResendClick = async () => {
    setSentCounter(sentCounter + 1);
    if (sentCounter >= EMAIL_SENT_LIMIT) {
      addToast({
        type: ToastType.WARNING,
        message: t("onboarding.mobile.email-limit-reached")
      });
      return;
    }
    try {
      await apiClient.post("/send_magic_link/", objToFormData({
        email: setupGuideInfo.email,
        isRegistration: false,
        isOrgSettingsPage: false
      }));
      addToast({
        type: ToastType.SUCCESS,
        message: t("onboarding.mobile.login-link-sent")
      });
    } catch (err) {
      reporter.error(err);
      addToast({
        type: ToastType.ERROR,
        message: t("onboarding.mobile.login-link-error")
      });
    }
  };
  const handleDismissClick = () => {
    setOpenModalModal(false);
    localStorageManager.setItem(MOBILE_MODAL_SHOWN_STORAGE_KEY, "true");
    track(TrackingEvent.MobileCloseModal);
  };
  const shouldShowMobileModal = () => {
    return isMobileDevice && !localStorageManager.getItem(MOBILE_MODAL_SHOWN_STORAGE_KEY) && openMobileModal;
  };
  return <ModalReact open={shouldShowMobileModal()} grow-to-content data-sentry-element="ModalReact" data-sentry-component="ImmersiveOnboardingMobile" data-sentry-source-file="immersive-onboarding-mobile.tsx">
      <div className={styles.mobileLayout}>
        <div className={styles.mobileHeaderImageContainer}>
          <img className={styles.mobileHeaderImage} src={IMMERSIVE_ASSETS.spot} />
        </div>
        <div>
          <Typography className={styles.mobileHeaderTitle} variant='headingLg' weight='bold' data-sentry-element="Typography" data-sentry-source-file="immersive-onboarding-mobile.tsx">
            {t("onboarding.mobile.bigger-is-better")}
          </Typography>
          <Typography className={styles.mobileHeaderDescription} variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="immersive-onboarding-mobile.tsx">
            {t("onboarding.mobile.best-on-computer")}
          </Typography>
          <div className={styles.mobileFooter}>
            <Button disabled={!setupGuideInfo || sentCounter > EMAIL_SENT_LIMIT} onClick={handleResendClick} size='medium' data-sentry-element="Button" data-sentry-source-file="immersive-onboarding-mobile.tsx">
              {sentCounter === 0 ? t("onboarding.mobile.email-login-link") : t("onboarding.mobile.resend")}
            </Button>
            <Button onClick={handleDismissClick} variant='transparent' size='medium' data-sentry-element="Button" data-sentry-source-file="immersive-onboarding-mobile.tsx">
              {t("common.dismiss")}
            </Button>
          </div>
        </div>
      </div>
    </ModalReact>;
};